import vue from 'vue';

export default function buildSequencePlateStore(store){
    store.actions.saveSequenceNotes = async (context, params) => await vue.prototype.$myHttp.post('/api/SequenceNoteLists/saveSequenceNotes', params);
    store.actions.findSequenceNotes = async (context, params) => await vue.prototype.$myHttp.post('/api/SequenceNoteLists/findSequenceNotes', params);
    store.actions.findSequenceOrderNotes = async (context, params) => await vue.prototype.$myHttp.post('/api/SequenceNoteLists/findSequenceOrderNotes', params);
    store.actions.saveSequenceOrderNote = async (context, params) => await vue.prototype.$myHttp.post('/api/SequenceNoteLists/saveSequenceOrderNote', params);
    return store;
}
